"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@/utils/cn";
import { Switch as AriaSwitch, SwitchProps as AriaSwitchProps, Label, Text } from "react-aria-components";
export interface SwitchProps extends Omit<AriaSwitchProps, "children"> {
  label?: string; // prefix label
  suffixLabel?: string; // suffix label
  description?: string;
  errorMessage?: string;
}

/**
 * Horizontally-aligned switch:
 *   [prefix label]  [toggle]  [suffix label]
 * Description and error message appear beneath.
 */
export function SwitchInput(t0) {
  const $ = _c(28);
  let className;
  let description;
  let errorMessage;
  let label;
  let props;
  let suffixLabel;
  if ($[0] !== t0) {
    ({
      label,
      suffixLabel,
      description,
      errorMessage,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = description;
    $[3] = errorMessage;
    $[4] = label;
    $[5] = props;
    $[6] = suffixLabel;
  } else {
    className = $[1];
    description = $[2];
    errorMessage = $[3];
    label = $[4];
    props = $[5];
    suffixLabel = $[6];
  }
  let t1;
  if ($[7] !== className) {
    t1 = cn("flex flex-col py-3 my-3 gap-2", className);
    $[7] = className;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== label) {
    t2 = label && <Label className="text-title-medium">{label}</Label>;
    $[9] = label;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== props) {
    t3 = <AriaSwitch {...props} className={_temp}>{_temp2}</AriaSwitch>;
    $[11] = props;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== suffixLabel) {
    t4 = suffixLabel && <span className="text-body text-muted-foreground">{suffixLabel}</span>;
    $[13] = suffixLabel;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t2 || $[16] !== t3 || $[17] !== t4) {
    t5 = <div className="flex items-center gap-2">{t2}{t3}{t4}</div>;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== description) {
    t6 = description && <Text slot="description" className="text-body-small">{description}</Text>;
    $[19] = description;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  const t7 = errorMessage || "";
  let t8;
  if ($[21] !== t7) {
    t8 = <Text slot="errorMessage" className="text-body-small-medium text-destructive h-1">{t7}</Text>;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t1 || $[24] !== t5 || $[25] !== t6 || $[26] !== t8) {
    t9 = <div className={t1}>{t5}{t6}{t8}</div>;
    $[23] = t1;
    $[24] = t5;
    $[25] = t6;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  return t9;
}
function _temp2(t0) {
  const {
    isSelected: isSelected_0
  } = t0;
  return <><span className="sr-only">{isSelected_0 ? "On" : "Off"}</span><div className={cn("pointer-events-none block size-5 rounded-full bg-background shadow-lg ring-0 transition-transform", isSelected_0 ? "translate-x-5" : "translate-x-0")} /></>;
}
function _temp(t0) {
  const {
    isSelected,
    isDisabled,
    isFocusVisible
  } = t0;
  return cn("group inline-flex h-6 w-11 shrink-0 items-center rounded-full border-2 border-transparent transition-colors", isDisabled && "cursor-not-allowed opacity-50", isSelected ? "bg-primary" : "bg-input", isFocusVisible && "outline-none ring-2 ring-ring ring-offset-2 ring-offset-background");
}